export default __webpack_public_path__ + "static/media/logoutlogo.146a49f7.svg";